import script from "./PublicLanding.vue?vue&type=script&setup=true&lang=js"
export * from "./PublicLanding.vue?vue&type=script&setup=true&lang=js"

import "./PublicLanding.vue?vue&type=style&index=0&id=3b2cab80&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b2cab80"]])

export default __exports__